var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as BaseProgress from "./BaseProgress";
export const Progress = forwardRef((props, ref) => {
    const { children, type = "linear" } = props, rootProps = __rest(props, ["children", "type"]);
    return (_jsxs(BaseProgress.Root, Object.assign({ ref: ref }, rootProps, { children: [children && _jsx(BaseProgress.Label, { children: children }), type === "linear" && (_jsx(BaseProgress.Track, { children: _jsx(BaseProgress.Range, {}) })), type === "circular" && (_jsxs(_Fragment, { children: [_jsx(BaseProgress.ValueText, { "data-type": "circular" }), _jsxs(BaseProgress.Circle, { children: [_jsx(BaseProgress.CircleTrack, {}), _jsx(BaseProgress.CircleRange, {})] })] }))] })));
});
Progress.displayName = "Progress";
//# sourceMappingURL=Progress.js.map